function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1964(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 19.56,
    height: 9.61,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.7392307692307691
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 4.805
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.61,
    width: 19.56,
    height: 12.82,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1366666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 16.02
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 22.42,
    width: 19.56,
    height: 13.21,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.8871428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 29.025000000000002
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 35.63,
    width: 19.56,
    height: 13.34,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9057142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 42.300000000000004
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 48.98,
    width: 19.56,
    height: 19.92,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 58.94
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 68.89,
    width: 19.56,
    height: 20.97,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 79.375
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 89.86,
    width: 19.56,
    height: 21.21,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.956
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 100.465
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 111.08,
    width: 19.56,
    height: 21.32,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 121.74
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 132.4,
    width: 19.56,
    height: 23.85,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 144.32500000000002
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 156.25,
    width: 19.56,
    height: 28.25,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.52
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 170.375
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 184.5,
    width: 19.56,
    height: 28.49,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.794285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 198.745
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 212.99,
    width: 19.56,
    height: 28.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 227.345
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 241.69,
    width: 19.56,
    height: 29.79,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.794285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 256.585
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 271.48,
    width: 19.56,
    height: 30.34,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 286.65000000000003
  }, "\n        Lanier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 301.82,
    width: 19.56,
    height: 31.06,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.794285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 317.34999999999997
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 332.88,
    width: 19.56,
    height: 31.96,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 348.86
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 364.84,
    width: 19.56,
    height: 33.3,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.912
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 381.48999999999995
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 398.14,
    width: 19.56,
    height: 34.53,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 415.405
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 432.67,
    width: 19.56,
    height: 34.78,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 450.06
  }, "\n        Long\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 467.45,
    width: 19.56,
    height: 36.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 485.91499999999996
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 504.38,
    width: 19.56,
    height: 37.83,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 523.295
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 542.21,
    width: 19.56,
    height: 38.53,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 561.475
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 580.75,
    width: 19.56,
    height: 39.35,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 600.425
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 620.09,
    width: 19.56,
    height: 39.7,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.912
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 639.94
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 659.79,
    width: 19.56,
    height: 40.21,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.794285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.78,
    y: 679.895
  }, "\n        Wheeler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 0,
    width: 26.99,
    height: 29.79,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.398
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 33.055,
    y: 14.895
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.55,
    y: 0,
    width: 27.77,
    height: 29.79,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.628333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.434999999999995,
    y: 14.895
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.32,
    y: 0,
    width: 27.9,
    height: 29.79,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.6499999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 88.27,
    y: 14.895
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.21,
    y: 0,
    width: 28.36,
    height: 29.79,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.726666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.38999999999999,
    y: 14.895
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.57,
    y: 0,
    width: 28.43,
    height: 29.79,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.55375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.785,
    y: 14.895
  }, "\n        Atkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 0,
    width: 28.7,
    height: 29.79,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 173.35,
    y: 14.895
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.7,
    y: 0,
    width: 28.73,
    height: 29.79,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.873
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 202.065,
    y: 14.895
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.44,
    y: 0,
    width: 28.86,
    height: 29.79,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.122857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 230.87,
    y: 14.895
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 245.3,
    y: 0,
    width: 29.02,
    height: 29.79,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.255
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 259.81,
    y: 14.895
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274.32,
    y: 0,
    width: 29.53,
    height: 29.79,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.218571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 289.085,
    y: 14.895
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 303.85,
    y: 0,
    width: 29.66,
    height: 29.79,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 318.68,
    y: 14.895
  }, "\n        Treutlen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 333.5,
    y: 0,
    width: 30.9,
    height: 29.79,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.72375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 348.95,
    y: 14.895
  }, "\n        Brantley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 364.4,
    y: 0,
    width: 31.97,
    height: 29.79,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.965
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 380.385,
    y: 14.895
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 396.37,
    y: 0,
    width: 32.47,
    height: 29.79,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.255714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 412.605,
    y: 14.895
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 428.84,
    y: 0,
    width: 33.02,
    height: 29.79,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.979
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 445.34999999999997,
    y: 14.895
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 461.86,
    y: 0,
    width: 33.06,
    height: 29.79,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.958
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 478.39,
    y: 14.895
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 494.93,
    y: 0,
    width: 33.41,
    height: 29.79,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.965
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 511.635,
    y: 14.895
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 528.34,
    y: 0,
    width: 33.89,
    height: 29.79,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.958
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 545.2850000000001,
    y: 14.895
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 562.23,
    y: 0,
    width: 34.12,
    height: 29.79,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.958
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 579.29,
    y: 14.895
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 596.35,
    y: 0,
    width: 34.23,
    height: 29.79,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.958
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 613.465,
    y: 14.895
  }, "\n        Evans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 630.58,
    y: 0,
    width: 34.52,
    height: 29.79,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.965
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 647.84,
    y: 14.895
  }, "\n        Turner\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 665.1,
    y: 0,
    width: 34.9,
    height: 29.79,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.255714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 682.5500000000001,
    y: 14.895
  }, "\n        Jenkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 29.79,
    width: 33.81,
    height: 30.94,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.188000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.465,
    y: 45.26
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 60.72,
    width: 33.81,
    height: 31.42,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.236666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.465,
    y: 76.43
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 92.14,
    width: 33.81,
    height: 31.68,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.525714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.465,
    y: 107.98
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 123.82,
    width: 33.81,
    height: 31.87,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.552857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.465,
    y: 139.755
  }, "\n        Candler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 155.69,
    width: 33.81,
    height: 33.18,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.295
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.465,
    y: 172.28
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 188.86,
    width: 33.81,
    height: 33.33,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3329999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.465,
    y: 205.525
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 222.19,
    width: 33.81,
    height: 33.34,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.1675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.465,
    y: 238.86
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 255.53,
    width: 33.81,
    height: 33.35,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.764285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.465,
    y: 272.205
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 288.89,
    width: 33.81,
    height: 34.27,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.635000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.465,
    y: 306.025
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 323.16,
    width: 33.81,
    height: 34.68,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.83
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.465,
    y: 340.5
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 357.83,
    width: 33.81,
    height: 35.07,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.7620000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.465,
    y: 375.365
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 392.9,
    width: 33.81,
    height: 35.55,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.7620000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.465,
    y: 410.67499999999995
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 428.46,
    width: 33.81,
    height: 35.61,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.7620000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.465,
    y: 446.265
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 464.07,
    width: 33.81,
    height: 37.69,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.635000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.465,
    y: 482.91499999999996
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 501.76,
    width: 33.81,
    height: 39.29,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.635000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.465,
    y: 521.405
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 541.05,
    width: 33.81,
    height: 39.51,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.635000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.465,
    y: 560.805
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 580.56,
    width: 33.81,
    height: 39.7,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.7620000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.465,
    y: 600.41
  }, "\n        Lamar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 620.27,
    width: 33.81,
    height: 39.85,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.7620000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.465,
    y: 640.1949999999999
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 660.12,
    width: 33.81,
    height: 39.88,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.756666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.465,
    y: 680.0600000000001
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.37,
    y: 29.79,
    width: 35.2,
    height: 38.35,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.866666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.97,
    y: 48.965
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.58,
    y: 29.79,
    width: 35.37,
    height: 38.35,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.0528571428571425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.265,
    y: 48.965
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123.95,
    y: 29.79,
    width: 35.54,
    height: 38.35,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.108
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.72,
    y: 48.965
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.49,
    y: 29.79,
    width: 35.72,
    height: 38.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.35000000000002,
    y: 48.965
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195.21,
    y: 29.79,
    width: 36.38,
    height: 38.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.0633333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.4,
    y: 48.965
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 231.59,
    y: 29.79,
    width: 37.18,
    height: 38.35,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.436
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 250.18,
    y: 48.965
  }, "\n        Bacon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 268.77,
    y: 29.79,
    width: 37.64,
    height: 38.35,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.182222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 287.59,
    y: 48.965
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306.41,
    y: 29.79,
    width: 37.8,
    height: 38.35,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.3
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 325.31,
    y: 48.965
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 344.21,
    y: 29.79,
    width: 38.08,
    height: 38.35,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.52
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 363.25,
    y: 48.965
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 382.28,
    y: 29.79,
    width: 38.97,
    height: 38.35,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.79375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 401.765,
    y: 48.965
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 421.26,
    y: 29.79,
    width: 39.2,
    height: 38.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.391666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 440.86,
    y: 48.965
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 460.45,
    y: 29.79,
    width: 39.2,
    height: 38.35,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.391666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 480.05,
    y: 48.965
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 499.65,
    y: 29.79,
    width: 39.6,
    height: 38.35,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.478571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 519.4499999999999,
    y: 48.965
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 539.25,
    y: 29.79,
    width: 39.88,
    height: 38.35,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.79375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 559.19,
    y: 48.965
  }, "\n        Bleckley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 579.13,
    y: 29.79,
    width: 39.88,
    height: 38.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.67
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 599.07,
    y: 48.965
  }, "\n        Peach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 619.01,
    y: 29.79,
    width: 40.46,
    height: 38.35,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.67
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 639.24,
    y: 48.965
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 659.48,
    y: 29.79,
    width: 40.52,
    height: 38.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.79375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 679.74,
    y: 48.965
  }, "\n        Ben_Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.37,
    y: 68.13,
    width: 40.59,
    height: 38.39,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.79875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.66499999999999,
    y: 87.32499999999999
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.37,
    y: 106.53,
    width: 40.59,
    height: 38.88,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.554285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.66499999999999,
    y: 125.97
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.37,
    y: 145.41,
    width: 40.59,
    height: 39.26,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.6085714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.66499999999999,
    y: 165.04
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.37,
    y: 184.67,
    width: 40.59,
    height: 40.06,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.0075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.66499999999999,
    y: 204.7
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.37,
    y: 224.73,
    width: 40.59,
    height: 40.11,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.7299999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.66499999999999,
    y: 244.785
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.37,
    y: 264.84,
    width: 40.59,
    height: 40.16,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.6933333333333325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.66499999999999,
    y: 284.91999999999996
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.37,
    y: 305,
    width: 40.59,
    height: 41.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.798571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.66499999999999,
    y: 325.58
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.37,
    y: 346.16,
    width: 40.59,
    height: 42.41,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.07375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.66499999999999,
    y: 367.365
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.37,
    y: 388.57,
    width: 40.59,
    height: 42.58,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.118
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.66499999999999,
    y: 409.86
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.37,
    y: 431.15,
    width: 40.59,
    height: 43.72,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.059
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.66499999999999,
    y: 453.01
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.37,
    y: 474.87,
    width: 40.59,
    height: 44.06,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.798571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.66499999999999,
    y: 496.9
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.37,
    y: 518.93,
    width: 40.59,
    height: 44.55,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.510000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.66499999999999,
    y: 541.2049999999999
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.37,
    y: 563.48,
    width: 40.59,
    height: 44.94,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.118
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.66499999999999,
    y: 585.95
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.37,
    y: 608.42,
    width: 40.59,
    height: 45.75,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.1475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.66499999999999,
    y: 631.295
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.37,
    y: 654.17,
    width: 40.59,
    height: 45.83,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.765000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.66499999999999,
    y: 677.0849999999999
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.97,
    y: 68.13,
    width: 42.1,
    height: 45.22,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.2625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 115.02,
    y: 90.74
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.07,
    y: 68.13,
    width: 42.43,
    height: 45.22,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.30375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 157.285,
    y: 90.74
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.5,
    y: 68.13,
    width: 43.68,
    height: 45.22,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 200.34,
    y: 90.74
  }, "\n        Barrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.19,
    y: 68.13,
    width: 44.45,
    height: 45.22,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 244.415,
    y: 90.74
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 266.64,
    y: 68.13,
    width: 46.16,
    height: 45.22,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.6525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 289.71999999999997,
    y: 90.74
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 312.8,
    y: 68.13,
    width: 46.31,
    height: 45.22,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.044
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 335.95500000000004,
    y: 90.74
  }, "\n        Grady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 359.11,
    y: 68.13,
    width: 46.71,
    height: 45.22,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.6525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 382.46500000000003,
    y: 90.74
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 405.83,
    y: 68.13,
    width: 47.64,
    height: 45.22,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.024444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 429.65,
    y: 90.74
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 453.47,
    y: 68.13,
    width: 48.11,
    height: 45.22,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.536666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 477.52500000000003,
    y: 90.74
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 501.58,
    y: 68.13,
    width: 48.44,
    height: 45.22,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.044
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 525.8,
    y: 90.74
  }, "\n        Crisp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 550.01,
    y: 68.13,
    width: 49.7,
    height: 45.22,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.536666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 574.86,
    y: 90.74
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 599.71,
    y: 68.13,
    width: 49.72,
    height: 45.22,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.536666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 624.57,
    y: 90.74
  }, "\n        Toombs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 649.43,
    y: 68.13,
    width: 50.57,
    height: 45.22,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.6525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 674.7149999999999,
    y: 90.74
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.97,
    y: 113.36,
    width: 51.43,
    height: 45.7,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.077777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.685,
    y: 136.21
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.97,
    y: 159.06,
    width: 51.43,
    height: 46,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.666666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.685,
    y: 182.06
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.97,
    y: 205.06,
    width: 51.43,
    height: 46.64,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.773333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.685,
    y: 228.38
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.97,
    y: 251.7,
    width: 51.43,
    height: 46.75,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.678571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.685,
    y: 275.075
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.97,
    y: 298.45,
    width: 51.43,
    height: 46.97,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.71
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.685,
    y: 321.935
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.97,
    y: 345.43,
    width: 51.43,
    height: 47.34,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.468
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.685,
    y: 369.1
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.97,
    y: 392.77,
    width: 51.43,
    height: 48.51,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.702
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.685,
    y: 417.025
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.97,
    y: 441.28,
    width: 51.43,
    height: 48.64,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.948571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.685,
    y: 465.59999999999997
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.97,
    y: 489.92,
    width: 51.43,
    height: 51.6,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.347142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.685,
    y: 515.72
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.97,
    y: 541.52,
    width: 51.43,
    height: 52.42,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.571666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.685,
    y: 567.73
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.97,
    y: 593.94,
    width: 51.43,
    height: 52.67,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.571666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.685,
    y: 620.2750000000001
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.97,
    y: 646.61,
    width: 51.43,
    height: 53.39,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.685,
    y: 673.3050000000001
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.39,
    y: 113.36,
    width: 51.76,
    height: 54.73,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.47
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.26999999999998,
    y: 140.725
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.16,
    y: 113.36,
    width: 52.72,
    height: 54.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.544
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 223.51999999999998,
    y: 140.725
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.88,
    y: 113.36,
    width: 52.89,
    height: 54.73,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.555714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 276.325,
    y: 140.725
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 302.77,
    y: 113.36,
    width: 54.5,
    height: 54.73,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 330.02,
    y: 140.725
  }, "\n        Tift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 357.28,
    y: 113.36,
    width: 55.57,
    height: 54.73,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.8185714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 385.065,
    y: 140.725
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412.84,
    y: 113.36,
    width: 55.57,
    height: 54.73,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.8185714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 440.625,
    y: 140.725
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.42,
    y: 113.36,
    width: 55.88,
    height: 54.73,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.121666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 496.36,
    y: 140.725
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 524.3,
    y: 113.36,
    width: 57.9,
    height: 54.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.121666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 553.25,
    y: 140.725
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 582.2,
    y: 113.36,
    width: 58.53,
    height: 54.73,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.121666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 611.465,
    y: 140.725
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 640.73,
    y: 113.36,
    width: 59.27,
    height: 54.73,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.8185714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 670.365,
    y: 140.725
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.39,
    y: 168.09,
    width: 62,
    height: 54.38,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.595
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.39,
    y: 195.28
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.39,
    y: 222.46,
    width: 62,
    height: 62.84,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.75
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.39,
    y: 253.88
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.39,
    y: 285.31,
    width: 62,
    height: 64.42,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.857142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.39,
    y: 317.52
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.39,
    y: 349.72,
    width: 62,
    height: 66.33,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.333333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.39,
    y: 382.88500000000005
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.39,
    y: 416.05,
    width: 62,
    height: 67.84,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.857142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.39,
    y: 449.97
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.39,
    y: 483.89,
    width: 62,
    height: 70.31,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.5
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.39,
    y: 519.045
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.39,
    y: 554.2,
    width: 62,
    height: 70.95,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.75
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.39,
    y: 589.6750000000001
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.39,
    y: 625.15,
    width: 62,
    height: 74.85,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.857142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.39,
    y: 662.5749999999999
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.4,
    y: 168.09,
    width: 65.91,
    height: 72.92,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.415714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 240.35500000000002,
    y: 204.55
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 273.3,
    y: 168.09,
    width: 66.7,
    height: 72.92,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.34
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 306.65000000000003,
    y: 204.55
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 168.09,
    width: 67.24,
    height: 72.92,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.206666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 373.62,
    y: 204.55
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407.24,
    y: 168.09,
    width: 70.06,
    height: 72.92,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.7844444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 442.27,
    y: 204.55
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 145,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 477.3,
    y: 168.09,
    width: 72.6,
    height: 72.92,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 513.6,
    y: 204.55
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 146,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 549.9,
    y: 168.09,
    width: 73.09,
    height: 72.92,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.153333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 586.4449999999999,
    y: 204.55
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 147,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 623,
    y: 168.09,
    width: 77,
    height: 72.92,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.584
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 661.5,
    y: 204.55
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 148,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.4,
    y: 241.01,
    width: 93.73,
    height: 62.09,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.76125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 254.26500000000001,
    y: 272.055
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 149,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.4,
    y: 303.1,
    width: 93.73,
    height: 75.1,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.728571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 254.26500000000001,
    y: 340.65000000000003
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 150,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.4,
    y: 378.19,
    width: 93.73,
    height: 82.7,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.18888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 254.26500000000001,
    y: 419.54
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 151,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.4,
    y: 460.9,
    width: 93.73,
    height: 85.51,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.102
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 254.26500000000001,
    y: 503.655
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 152,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.4,
    y: 546.41,
    width: 93.73,
    height: 153.59,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.71625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 254.26500000000001,
    y: 623.2049999999999
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 153,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 301.13,
    y: 241.01,
    width: 120.44,
    height: 125.09,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.055
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 361.35,
    y: 303.555
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 154,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 421.57,
    y: 241.01,
    width: 128.97,
    height: 125.09,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 31.2725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 486.055,
    y: 303.555
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 155,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 550.54,
    y: 241.01,
    width: 149.46,
    height: 125.09,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 31.2725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 625.27,
    y: 303.555
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 156,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 301.13,
    y: 366.1,
    width: 184.08,
    height: 131.58,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.79714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 393.17,
    y: 431.89000000000004
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 157,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 301.13,
    y: 497.67,
    width: 184.08,
    height: 202.33,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 30.680000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 393.17,
    y: 598.835
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 158,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 485.21,
    y: 366.1,
    width: 214.79,
    height: 333.9,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 35.79833333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 592.605,
    y: 533.05
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1964);
export default __webpack_public_path__ + "static/media/1964.05ee563e03cb00afb3de3ae762fcee22.svg";
export { ForwardRef as ReactComponent };